import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  ref: "shell",
  class: "auth-shell"
}
const _hoisted_2 = {
  class: "auth-bg",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  ref: "dotField",
  class: "dot-field",
  viewBox: "0 0 1600 900",
  preserveAspectRatio: "xMidYMid slice"
}
const _hoisted_4 = ["cx", "cy"]
const _hoisted_5 = { class: "auth-content d-flex flex-column" }
const _hoisted_6 = { class: "container flex-grow-1 d-flex align-items-center py-5" }
const _hoisted_7 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orbs, (orb, i) => {
        return (_openBlock(), _createElementBlock("span", {
          key: `orb-${i}`,
          class: _normalizeClass(["orb", orb.variant]),
          style: _normalizeStyle({
          '--x': orb.x,
          '--y': orb.y,
          '--s': orb.s,
          '--a': orb.a,
        })
        }, null, 6))
      }), 128)),
      (_openBlock(), _createElementBlock("svg", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dots, (dot, i) => {
          return (_openBlock(), _createElementBlock("circle", {
            key: `dot-${i}`,
            cx: dot.x,
            cy: dot.y,
            style: _normalizeStyle({ '--cx': dot.x, '--cy': dot.y })
          }, null, 12, _hoisted_4))
        }), 128))
      ], 512)),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "vignette" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_view)
        ])
      ]),
      _cache[1] || (_cache[1] = _createStaticVNode("<footer class=\"auth-footer pb-4\" data-v-5dd0871e><ul class=\"list-unstyled d-flex justify-content-center gap-3 mb-0 fs-5\" data-v-5dd0871e><li data-v-5dd0871e><a href=\"https://www.instagram.com/gtracademy.oficial/\" class=\"social-link\" target=\"_blank\" aria-label=\"Instagram\" data-v-5dd0871e><i class=\"fa-brands fa-instagram\" data-v-5dd0871e></i></a></li><li data-v-5dd0871e><a href=\"https://www.facebook.com/generaturiquezaclub\" class=\"social-link\" target=\"_blank\" aria-label=\"Facebook\" data-v-5dd0871e><i class=\"fa-brands fa-facebook\" data-v-5dd0871e></i></a></li><li data-v-5dd0871e><a href=\"https://www.youtube.com/channel/UCZOM8O0GcCLUQvx5YmuPsTQ\" class=\"social-link\" target=\"_blank\" aria-label=\"YouTube\" data-v-5dd0871e><i class=\"fa-brands fa-youtube\" data-v-5dd0871e></i></a></li></ul></footer>", 1))
    ])
  ], 512))
}